<app-common-header-section></app-common-header-section>	
	  

<div class="errorPage" id="errorcontent">
        <p style="text-align: center; color: red">{{errorMessage}}</p>
        <p style="text-align: center;"><a href="javascript:void(0);" (click)="refresh()">Please retry here</a></p>    
</div>

